import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["grid"]

  connect() {
    this.originalOrder = Array.from(this.gridTarget.children)
  }

  toggle(event) {
    if (event.target.checked) {
      this.shuffle()
    } else {
      this.restore()
    }
  }

  shuffle() {
    const items = Array.from(this.gridTarget.children)
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]]
    }
    items.forEach(el => this.gridTarget.appendChild(el))
  }

  restore() {
    this.originalOrder.forEach(el => this.gridTarget.appendChild(el))
  }
}
